import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { computed } from "@vue/reactivity";
import { provide, ComputedRef } from "vue";

export type ProvideTab = {
  selected: ComputedRef<boolean>;
};

interface ProviderProps {
  selected: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Provider',
  props: {
    selected: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { selected: boolean }



provide<ProvideTab>("tab", {
  selected: computed(() => props.selected),
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})